import { RecordUtils } from "@rsm-hcd/javascript-core";
import { Record } from "immutable";
import { NotebookPermissionRecipient } from "models/interfaces/notebooks/notebook-permission-recipient";

const defaultValues: NotebookPermissionRecipient =
    RecordUtils.defaultValuesFactory<NotebookPermissionRecipient>({
        id: undefined,
        name: undefined,
        type: undefined,
        count: undefined,
        email: undefined,
    });

export default class NotebookPermissionRecipientRecord
    extends Record(defaultValues)
    implements NotebookPermissionRecipient
{
    constructor(params?: Partial<NotebookPermissionRecipient>) {
        if (params == null) {
            params = Object.assign({}, defaultValues);
        }

        super(params);
    }
}
